module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Screens/author/author.component.css
// module id = ./src/app/Screens/author/author.component.css
// module chunks = main